<template>
  <div v-if="showPwaInstall && boolCanGetAward" class="pwa-award">
    <a class="pwa-award-btn" href="javascript:;" @click="beforeGetAward" :style="pwaInstall">
      <div class="pwa-award-btn-text">
        <span>{{ letter.getAward }}</span>
      </div>
    </a>
    <transition name="fade">
      <PwaRoleSelect
        v-if="visibleRoleSelect"
        @close="switchVisibleRoleSelect(false)"
        @showTipPopup="showTipPopup"
      ></PwaRoleSelect>
    </transition>
    <PopupWindow
      v-if="visibleTipPopup"
      type="tips"
      :languages="letter"
      :content="popupTip"
      textAlign="center"
      @onConfirm="visibleTipPopup = false"
      @onCancel="visibleTipPopup = false"
    ></PopupWindow>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import PwaRoleSelect from '@components/officialWebStore/activity/PwaRoleSelect.vue';
import { GET_AWARD_BASIC } from '@store/officialWebStore/award';
import globalConfig from '@utiles/officialStore/globalConfig.js';
import {
  popupType,
  showPopup,
  clickButton
} from '@plugins/biPoint/_configWebstoreV2';

export default {
  name: 'PwaAward',
  props: {
    isInstall: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      boolCanGetAward: false,
      visibleRoleSelect: false,
      visibleTipPopup: false,
      popupTip: '',
      isFormPwa: globalConfig.getHrefParam('cid') === 'shortcut' || globalConfig.getHrefParam('scid').includes('shortcut') || globalConfig.getHrefParam('mode') === 'pwa'
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      isLogin: state => state.login.isLogin
    }),
    ...mapGetters(['gameInfoConfig']),
    pwaInstall() {
      if (this.gameInfoConfig?.pwaInstall) {
        return `background-image:url(${this.gameInfoConfig?.pwaInstall})`;
      }
      return '';
    },
    showPwaInstall() {
      return this.gameInfoConfig?.pwaAward?.open || false;
    },
    listenChange() {
      return {
        isLogin: this.isLogin,
        isInstall: this.isInstall,
        isFormPwa: this.isFormPwa
      };
    }
  },
  methods: {
    showTipPopup(content) {
      this.popupTip = content;
      this.visibleTipPopup = true;
    },
    beforeGetAward() {
      this.switchVisibleRoleSelect(true);
      clickButton({
        btnName: 'get_pwa_award',
        locationKey: this.$route.meta.pageName
      });
    },
    switchVisibleRoleSelect(bool) {
      this.visibleRoleSelect = bool;

      if (bool) {
        showPopup(popupType.pwaBindRolePopup);
      }
    },
    async initAward() {
      const res = await this.$store.dispatch(GET_AWARD_BASIC);
      if (+res?.result === 1 && res?.data?.giftList?.length > 0) {
        const awardInfo = res?.data?.giftList?.find(
          item => item?.groupId === 'no_sendCoupon'
        );
        if (awardInfo?.list?.length > 0) {
          const awardInfItem = awardInfo?.list[0];
          if (awardInfItem?.hasOwnProperty('awardState')) {
            // 可以领取
            this.boolCanGetAward = +awardInfItem?.awardState === 1;
            return;
          }
        }
      }
      // 不可以领取
      this.boolCanGetAward = false;
    }
  },
  watch: {
    listenChange(newObj) {
      newObj.isLogin &&
        (newObj.isInstall || newObj.isFormPwa) &&
        this.initAward();
    }
  },
  components: {
    PwaRoleSelect
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';

.pwa-award {
  &-btn {
    overflow: hidden;
    position: fixed;
    z-index: 9;
    right: 0;
    top: 120px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    // @psetbg ('pwa-install.png');
    width: 241px;
    height: 95px;

    &-text {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      /*!rtl:ignore*/
      padding: 0 12px 0 98px;
      font-size: 22px;

      span {
        text-align: center;
        // 文字渐变色
        font-weight: bold;
        -webkit-background-clip: text;
        color: transparent; /* Fallback for non-webkit browsers */
        background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: linear-gradient(to bottom, #ffe070, #ffffff);

        // 文字描边阴影
        // text-shadow: -1px -1px 10px rgba(0, 0, 0, 0.4),
        //   1px -1px 10px rgba(0, 0, 0, 0.4), -1px 1px 10px rgba(0, 0, 0, 0.4),
        //   1px 1px 10px rgba(0, 0, 0, 0.4);
      }
    }
  }
}
</style>
